class PriorityProcessingComponent extends HTMLElement {
  constructor() {
    super();
    this._isUpdating = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.variantId = this.dataset.variantId;
    this.toggle = this.querySelector('[data-priority-processing-toggle]');

    if (!this.variantId || !this.toggle) return;

    this.toggle.addEventListener("change", this.onToggleChange.bind(this));
    this.syncWithCart();
  }

  syncWithCart() {
    const itemsInCart = Number(this.dataset.itemsInCart || 0);
    const inCart = this.dataset.inCart === "true";

    if (itemsInCart < 1) {
      if (inCart) this.removePriorityProcessingFromEmptyCart();
      return;
    }

    if (this.dataset.optedOut === "true" || inCart) return;

    this.toggle.checked = true;
    this.enablePriorityProcessing();
  }

  removePriorityProcessingFromEmptyCart() {
    this.setLoading(true);
    this.updateCart(
      {
        updates: {
          [this.variantId]: 0,
        },
        sections: this.getSectionsToUpdate(),
      },
      { revertToggleOnError: false }
    );
  }

  onToggleChange(event) {
    if (this._isUpdating) {
      event.target.checked = !event.target.checked;
      return;
    }

    if (event.target.checked) {
      this.enablePriorityProcessing();
    } else {
      this.disablePriorityProcessing();
    }
  }

  setLoading(isLoading) {
    this._isUpdating = isLoading;
    this.classList.toggle("is-loading", isLoading);
  }

  enablePriorityProcessing() {
    this.setLoading(true);
    this.updateCart({
      updates: {
        [this.variantId]: 1,
      },
      attributes: { "priority-processing": true },
      sections: this.getSectionsToUpdate(),
    });
  }

  disablePriorityProcessing() {
    this.setLoading(true);
    this.updateCart({
      updates: {
        [this.variantId]: 0,
      },
      attributes: { "priority-processing": false },
      sections: this.getSectionsToUpdate(),
    });
  }

  getSectionsToUpdate() {
    const sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", { bubbles: true, detail: { sections } })
    );
    return sections;
  }

  updateCart(body, { revertToggleOnError = true } = {}) {
    const headers = new Headers({ "Content-Type": "application/json", Accept: "application/json" });

    return fetch(`${MinimogSettings.routes.cart_update_url}`, {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response.status || response.description) {
          throw new Error(response.description || "Cart update failed");
        }

        MinimogEvents.emit(MinimogTheme.pubSubEvents.cartUpdate, { cart: response });
        document.dispatchEvent(
          new CustomEvent("cart:updated", {
            detail: { cart: response },
          })
        );
      })
      .catch((error) => {
        console.error(error);
        if (revertToggleOnError && this.toggle) this.toggle.checked = !this.toggle.checked;
      })
      .finally(() => {
        if (this.isConnected) {
          this.setLoading(false);
        }
      });
  }
}

if (!customElements.get("m-priority-processing-component")) {
  customElements.define("m-priority-processing-component", PriorityProcessingComponent);
}
